import { BiError } from "react-icons/bi";
import { FiAlertTriangle, FiTool } from "react-icons/fi";
import { HiOutlineLockClosed } from "react-icons/hi";

const viewStates = {
  default: {
    Icon: HiOutlineLockClosed,
    title: "Please Enter Code",
    body: undefined,
    showInput: true,
    showTroubleshoot: true,
    showLostCode: true,
  },
  maintenance: {
    Icon: FiTool,
    title: "We'll be back soon!",
    body: "We’re very sorry for the inconvenience, we’re currently performing maintenance. Please check back soon…",
    showInput: false,
    showLostCode: false,
  },
  invalid: {
    Icon: FiAlertTriangle,
    title: "Invalid Code",
    body: "Please Re-Enter Your Code",
    showTroubleshoot: true,
    showInput: true,
    showLostCode: true,
  },
  error: {
    Icon: BiError,
    title: "404 - PAGE NOT FOUND",
    body: "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.",
    showInput: false,
    showLostCode: false,
    showGoHome: true,
  },
} satisfies TViewProps;

export default viewStates;
